import React, { useState } from 'react';
import { useIntl } from 'react-intl-next';
import Textfield from '@atlaskit/textfield';
import { FireUIAnalytics } from '@atlassian/analytics-bridge';
import { Action, ActionSubject } from '@atlassian/proforma-utils/analytics';
import { PackageIntlProvider } from '../../../common/utils/intl-provider';
import { useProjectFormsController } from '../../../controllers';
import { messages } from './messages';
import { ListProjectFormsWrapper, RequestTypeWrapper, SmallSearchIcon, TableWrapper, TextfieldWrapper, TopBar } from './styled';
import { Table } from './table';
import { TicketTypeDropdown } from './ticket-type-dropdown';
export const ListProjectForms = ({
  projectKey,
  projectType,
  simplifiedProject,
  userIsProjectAdmin
}) => {
  const intl = useIntl();
  const [{
    forms,
    loading
  }] = useProjectFormsController();
  const isServiceProject = projectType === 'service_desk';
  const [searchTextFilter, setSearchTextFilter] = useState('');
  const [filteredTypeIds, setFilteredTypeIds] = useState([]);
  return /*#__PURE__*/React.createElement(PackageIntlProvider, {
    locale: intl.locale
  }, /*#__PURE__*/React.createElement(ListProjectFormsWrapper, null, /*#__PURE__*/React.createElement(TopBar, null, /*#__PURE__*/React.createElement(TextfieldWrapper, null, /*#__PURE__*/React.createElement(Textfield, {
    elemAfterInput: /*#__PURE__*/React.createElement(SmallSearchIcon, {
      label: ""
    }),
    onChange: e => setSearchTextFilter(e.target.value),
    placeholder: intl.formatMessage(messages.formsFilterPlaceholder),
    isCompact: true,
    "aria-label": intl.formatMessage(messages.formsFilterPlaceholder)
  })), /*#__PURE__*/React.createElement(RequestTypeWrapper, null, /*#__PURE__*/React.createElement(TicketTypeDropdown, {
    isServiceProject: isServiceProject,
    onChange: setFilteredTypeIds
  }))), /*#__PURE__*/React.createElement(TableWrapper, null, /*#__PURE__*/React.createElement(Table, {
    projectKey: projectKey,
    projectType: projectType,
    simplifiedProject: simplifiedProject,
    userIsProjectAdmin: userIsProjectAdmin,
    searchTextFilter: searchTextFilter,
    filteredTypeIds: filteredTypeIds
  }), !loading && /*#__PURE__*/React.createElement(FireUIAnalytics, {
    actionSubject: ActionSubject.LIST,
    action: Action.VIEWED,
    actionSubjectId: "templateFormsList",
    attributes: {
      templateFormsCount: forms.length
    }
  }))));
};